import { API_TYPE } from '@umu/umu-fetch';
const BASE = '/uapi/v1';
const BASE_MODULE = '/micro-page';
export const MicroPageApi = {
    ADD_MICRO_PAGE: {
        url: `${BASE}${BASE_MODULE}/page/save-basic`, // 添加微页面
        type: API_TYPE.POST,
    },
    COPY_MICRO_PAGE: {
        url: `${BASE}${BASE_MODULE}/page/copy`,// 复制微页面
        type: API_TYPE.POST,
    },
    GET_MICRO_PAGE_LIST: {
        url: `${BASE}${BASE_MODULE}/page/list`, // 获取微页面配置列表信息
        type: API_TYPE.GET,
    },
}
